<template>
  <v-content class="pa-12">
    <!-- Nevigater -->
    <v-layout mb-6>
      <v-flex shrink d-flex justify-start align-center style="color: #3E7662;font-weight: bold;font-size: 24px;">
        <span>แบบฟอร์ม RF ทั้งหมด</span>
      </v-flex>
    </v-layout>

    <v-layout mt-6>
      <v-flex shrink style="font-weight: bold;">
        <span>กรองประเภท</span>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex style="color: #3E7662;">
        <v-radio-group hide-details v-model="filterType">
          <v-layout class="my-1">
            <v-flex class="xs6 py-1">
              <v-layout>
                <v-flex class="xs1 align-center d-flex justify-end">
                  <v-icon v-if="countRF12 > 0" small color="#CC3D45">mdi-alert-circle
                  </v-icon>
                  <span style="color: #CC3D45;font-weight: bold;font-size: 14px" v-if="countRF12 > 0">{{ countRF12
                  }}</span>
                </v-flex>
                <v-flex xs11>
                  <v-radio class="ml-3" @click.native="checkRadio('1')" :class="checkRadio1 ? 'radio-checked' : ''"
                    color="#3E7662" label="แบบรายงานการแก้ไขเพิ่มเติมโครงร่างการวิจัย (RF 12_2563)" value="1" />
                  <!--                             label="รายงานแก้ไขเพิ่มเติมโครงร่างการวิจัย (Amendment Protocol)"-->
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex class="xs6 py-1">
              <v-layout>
                <v-flex class="xs1 align-center d-flex justify-end">
                  <v-icon v-if="countRF03 > 0" small color="#CC3D45">mdi-alert-circle
                  </v-icon>
                  <span style="color: #CC3D45;font-weight: bold;font-size: 14px" v-if="countRF03 > 0">{{ countRF03
                  }}</span>
                </v-flex>
                <v-flex xs11>
                  <v-radio class="ml-3" @click.native="checkRadio('4')" :class="checkRadio4 ? 'radio-checked' : ''"
                    color="#3E7662" label="แบบรายงานความก้าวหน้าของการวิจัย/ขอต่ออายุโครงการ (RF 03_2563)" value="4" />
                  <!--                             label="รายงานความก้าวหน้าและขอต่ออายุโครงการวิจัย (Progress Report)"-->
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout class="my-1">
            <v-flex class="xs6 py-1">
              <v-layout>
                <v-flex class="xs1 align-center d-flex justify-end">
                  <v-icon v-if="countRF04_2 > 0" small color="#CC3D45">mdi-alert-circle
                  </v-icon>
                  <span style="color: #CC3D45;font-weight: bold;font-size: 14px" v-if="countRF04_2 > 0">{{ countRF04_2
                  }}</span>
                </v-flex>
                <v-flex xs11>
                  <v-radio class="ml-3" @click.native="checkRadio('8')" :class="checkRadio8 ? 'radio-checked' : ''"
                    color="#3E7662" label="แบบรายงานเหตุการณ์ไม่พึงประสงค์จากยา/เหตุการณ์ไม่คาดคิดจากยา (RF 04_1_2563)"
                    value="8" />
                  <!--                             label="รายงานเหตุการณ์การไม่พึ่งประสงค์จากยา (Adverse Drug Reaction Report)"-->
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex class="xs6 py-1">
              <v-layout>
                <v-flex class="xs1 align-center d-flex justify-end">
                  <v-icon v-if="countRF06 > 0" small color="#CC3D45">mdi-alert-circle
                  </v-icon>
                  <span style="color: #CC3D45;font-weight: bold;" v-if="countRF06 > 0">{{ countRF06 }}</span>
                </v-flex>
                <v-flex xs11>
                  <v-radio class="ml-3" @click.native="checkRadio('5')" :class="checkRadio5 ? 'radio-checked' : ''"
                    color="#3E7662" label="แบบรายงานแจ้งปิด/สรุปผลการวิจัย (RF 06_2563)" value="5" />
                  <!--                             label="รายงานสรุปผลการวิจัย (Final Report)"-->
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout class="my-1">
            <v-flex class="xs6 py-1">
              <v-layout>
                <v-flex class="xs1 align-center d-flex justify-end">
                  <v-icon v-if="countRF04_1 > 0" small color="#CC3D45">mdi-alert-circle
                  </v-icon>
                  <span style="color: #CC3D45;font-weight: bold;font-size: 14px" v-if="countRF04_1 > 0">{{ countRF04_1
                  }}</span>
                </v-flex>
                <v-flex xs11>
                  <v-radio class="ml-3" @click.native="checkRadio('2')" :class="checkRadio2 ? 'radio-checked' : ''"
                    color="#3E7662" label="แบบรายงานเหตุการณ์ไม่พึงประสงค์ (SAE) (RF 04_2_2563)" value="2" />
                  <!--                             label="รายงานเหตุการณ์การไม่พึ่งประสงค์ (SAE Report)"-->
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex class="xs6 py-1">
              <v-layout>
                <v-flex class="xs1 align-center d-flex justify-end">
                  <v-icon v-if="countRF07 > 0" small color="#CC3D45">mdi-alert-circle
                  </v-icon>
                  <span style="color: #CC3D45;font-weight: bold;font-size: 14px" v-if="countRF07 > 0">{{ countRF07
                  }}</span>
                </v-flex>
                <v-flex xs11>
                  <v-radio class="ml-3" @click.native="checkRadio('7')" :class="checkRadio7 ? 'radio-checked' : ''"
                    color="#3E7662" label="แบบรายงานการยุติโครงการวิจัยก่อนกําหนด (RF 07_2563)" value="7" />
                  <!--                             label="แจ้งปิดโครงการวิจัยก่อนกำหนด (Terminate)"-->
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout class="my-1">
            <v-flex class="xs6 py-1">
              <v-layout>
                <v-flex class="xs1 align-center d-flex justify-end">
                  <v-icon v-if="countRF05 > 0" small color="#CC3D45">mdi-alert-circle
                  </v-icon>
                  <span style="color: #CC3D45;font-weight: bold;font-size: 14px" v-if="countRF05 > 0">{{ countRF05
                  }}</span>
                </v-flex>
                <v-flex xs11>
                  <v-radio class="ml-3" @click.native="checkRadio('3')" :class="checkRadio3 ? 'radio-checked' : ''"
                    color="#3E7662" label="แบบรายงานการไม่ปฏิบัติตามข้อกำหนด (RF 05_2563)" value="3" />
                  <!--                             label="รายงานการเบี่ยงเบนโครงร่างวิจัย (Deviation Report)"-->
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex class="xs6 py-1">
              <v-layout>
                <v-flex class="xs1 align-center d-flex justify-end">
                  <v-icon v-if="countCorres > 0" small color="#CC3D45">mdi-alert-circle</v-icon>
                  <span style="color: #CC3D45;font-weight: bold;font-size: 14px" v-if="countCorres > 0">{{ countCorres
                  }}</span>
                </v-flex>
                <v-flex xs11>
                  <v-radio class="ml-3" @click.native="checkRadio('6')" :class="checkRadio6 ? 'radio-checked' : ''"
                    color="#3E7662" label="เอกสารและจดหมายแจ้งเกี่ยวกับงานวิจัย (Correspondence Report)" value="6" />
                  <!--                             label="แจ้งปิดโครงการวิจัยก่อนกำหนด (Terminate)"-->
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout class="my-1">
            <v-flex class="xs6 py-1"></v-flex>
            <v-flex class="xs6 py-1">
              <v-layout>
                <v-flex class="xs1 align-center d-flex justify-end">
                  <v-icon v-if="countSusar > 0" small color="#CC3D45">mdi-alert-circle</v-icon>
                  <span style="color: #CC3D45;font-weight: bold;font-size: 14px" v-if="countSusar > 0">{{ countSusar
                  }}</span>
                </v-flex>
                <v-flex xs11>
                  <v-radio class="ml-3" @click.native="checkRadio('9')" :class="checkRadio9 ? 'radio-checked' : ''"
                    color="#3E7662" label="แบบรายงานเหตุการณ์ไม่พึ่งประสงค์นอกสถาบัน SUSAR / DMC / DSMB" value="9" />
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

        </v-radio-group>
      </v-flex>
    </v-layout>

    <v-layout my-6>
      <v-flex xs3>
        <v-text-field placeholder="รหัสโครงการวิจัย" color="#3e7662" dense outlined v-model="searchData.researchCode"
          hide-details />
      </v-flex>
      <v-flex xs3 mx-6>
        <v-text-field placeholder="ชื่อ นามสกุล ผู้วิจัย" color="#3e7662" dense outlined
          v-model="searchData.researcherName" hide-details />
      </v-flex>
      <v-flex shrink>
        <v-btn color="#3e7662" dark @click="getRFAll(1)">
          <span class="font-weight-bold">ค้นหา</span>
        </v-btn>
      </v-flex>
    </v-layout>

    <!-- Table -->
    <v-layout mt-4>
      <v-flex>
        <form-table :headers="headers" :items="listRF" onViewData :verifyRF="verifyRF"
          :viewCorresFile="viewCorresFile"></form-table>
      </v-flex>
    </v-layout>

    <!-- Pagination -->
    <v-layout mt-12>
      <v-flex>
        <v-pagination color="#3E7662" :length="paginate.last_page" :total-visible="9" @input="getRFAll"
          v-model="paginate.current_page"></v-pagination>
      </v-flex>
    </v-layout>

    <!-- Modal  -->
    <template>
      <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="700px">
          <v-card>
            <!-- Header -->
            <v-card-title class="mb-4 justify-center" style="background-color: #3e7662;color: white;">
              <span class="font-weight-medium font-weight-bold">ผลการพิจารณา</span>
            </v-card-title>
            <v-card-text>
              <v-layout>
                <v-flex xs3 mr-3 justify-end align-center d-flex>
                  <span style="font-weight: bold;font-weight: bold;font-size: 16px;">ชื่องานวิจัย</span>
                </v-flex>
                <v-flex xs9>
                  <TextfieldForm readonly :model="form.name" hide-detail />
                </v-flex>
              </v-layout>
              <v-layout mt-6>
                <v-flex xs3 mr-3 justify-end align-center d-flex>
                  <span style="font-weight: bold;font-weight: bold;font-size: 16px;">ผลการพิจารณา</span>
                </v-flex>
                <v-flex xs9 class="field-select">
                  <v-select hide-details clearable :menu-props="{ bottom: true, offsetY: true }"
                    background-color="#3E7662" solo flat dense label="เลือกผลการพิจารณา" :items="verifyList"
                    item-text="name" item-value="name" v-model="form.status" @change="clearForm()"></v-select>
                </v-flex>
              </v-layout>

              <div v-if="form.status === 'ผ่านการพิจารณา'">
                <!-- รายงานเหตุการณ์การไม่พึ่งประสงค์ (research Amendment) -->
                <v-layout v-if="filterType === '1'">
                  <v-flex>
                    <v-layout class="mt-4">
                      <v-flex>
                        <span class="font-weight-bold" style="font-size: 18px;">แบบรายงานการแก้ไขเพิ่มเติมโครงร่างการวิจัย
                          (Amendment
                          Report)</span>
                      </v-flex>
                    </v-layout>
                    <v-layout class="my-8 px-6">
                      <v-flex class="text-start">
                        <span style="font-weight: bold;font-size: 18px;">รับรอง & รับทราบ เอกสาร</span>
                      </v-flex>
                    </v-layout>

                    <v-layout class="my-8 px-6">
                      <v-flex class="text-start">
                        <span style="font-weight: bold;font-size: 18px;">เอกสาร information sheet / Consent form</span>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex shrink mx-1>
                        <span style="font-weight: bold">รับรอง</span>
                      </v-flex>
                      <v-flex shrink mx-1>
                        <span style="font-weight: bold">รับทราบ</span>
                      </v-flex>
                      <v-flex class="justify-end text-right" style="font-weight: bold">
                        เปลี่ยนชื่อเอกสาร
                      </v-flex>
                      <v-flex xs3></v-flex>
                    </v-layout>
                    <v-layout v-for="(fileInformationSheet,
                      index) in fileList.fileInformationSheet" :key="'A' + index">
                      <v-flex row ml-2 xs2>
                        <v-checkbox @click.native="
                          checkboxClick(
                            'informedFile',
                            'fileInformationSheet',
                            fileInformationSheet.value
                          )
                          " v-model="guaranteeFile.fileInformationSheet" color="#3e7662"
                          :value="fileInformationSheet.value" class="mx-1"></v-checkbox>
                        <v-checkbox @click.native="
                          checkboxClick(
                            'guaranteeFile',
                            'fileInformationSheet',
                            fileInformationSheet.value
                          )
                          " v-model="informedFile.fileInformationSheet" color="#3e7662"
                          :value="fileInformationSheet.value" class="mx-2"></v-checkbox>
                      </v-flex>
                      <v-flex xs6>
                        <a :href="fileInformationSheet.path" style="color: #3e7662;" target="_blank">
                          <span class="d-flex mt-1">{{
                            fileInformationSheet.fileName
                          }}</span>
                        </a>
                      </v-flex>
                      <v-flex>
                        <v-checkbox color="#3e7662" v-model="fileInformationSheet.isChangeName" @click="
                          fileInformationSheet.isChangeName
                            ? (fileInformationSheet.newName =
                              fileInformationSheet.newName)
                            : (fileInformationSheet.newName = '')
                          "></v-checkbox>
                      </v-flex>
                      <v-flex ml-4>
                        <v-text-field color="#3e7662" :disabled="!fileInformationSheet.isChangeName" outlined dense
                          v-model="fileInformationSheet.newName" placeholder="ตั้งชื่อเอกสาร"></v-text-field>
                      </v-flex>
                    </v-layout>

                    <v-layout class="my-8 px-6">
                      <v-flex class="text-start">
                        <span style="font-weight: bold;font-size: 18px;">เอกสาร Protocol Modification or Amendment</span>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex shrink mx-1>
                        <span style="font-weight: bold">รับรอง</span>
                      </v-flex>
                      <v-flex shrink mx-1>
                        <span style="font-weight: bold">รับทราบ</span>
                      </v-flex>
                      <v-flex class="justify-end text-right" style="font-weight: bold">
                        เปลี่ยนชื่อเอกสาร
                      </v-flex>
                      <v-flex xs3></v-flex>
                    </v-layout>
                    <v-layout v-for="(fileProtocolModify,
                      index) in fileList.fileProtocolModify" :key="'B' + index">
                      <v-flex row ml-2 xs2>
                        <v-checkbox @click.native="
                          checkboxClick(
                            'informedFile',
                            'fileProtocolModify',
                            fileProtocolModify.value
                          )
                          " v-model="guaranteeFile.fileProtocolModify" color="#3e7662"
                          :value="fileProtocolModify.value" class="mx-1"></v-checkbox>
                        <v-checkbox @click.native="
                          checkboxClick(
                            'guaranteeFile',
                            'fileProtocolModify',
                            fileProtocolModify.value
                          )
                          " v-model="informedFile.fileProtocolModify" color="#3e7662" :value="fileProtocolModify.value"
                          class="mx-2"></v-checkbox>
                      </v-flex>
                      <v-flex xs6>
                        <a :href="fileProtocolModify.path" style="color: #3e7662;" target="_blank">
                          <span class="d-flex mt-1">{{
                            fileProtocolModify.fileName
                          }}</span>
                        </a>
                      </v-flex>
                      <v-flex>
                        <v-checkbox color="#3e7662" v-model="fileProtocolModify.isChangeName" @click="
                          fileProtocolModify.isChangeName
                            ? (fileProtocolModify.newName =
                              fileProtocolModify.newName)
                            : (fileProtocolModify.newName = '')
                          "></v-checkbox>
                      </v-flex>
                      <v-flex ml-4>
                        <v-text-field color="#3e7662" :disabled="!fileProtocolModify.isChangeName" outlined dense
                          v-model="fileProtocolModify.newName" placeholder="ตั้งชื่อเอกสาร"></v-text-field>
                      </v-flex>
                    </v-layout>

                    <v-layout class="my-8 px-6">
                      <v-flex class="text-start">
                        <span style="font-weight: bold;font-size: 18px;">เอกสาร Investigator Brochure</span>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex shrink mx-1>
                        <span style="font-weight: bold">รับรอง</span>
                      </v-flex>
                      <v-flex shrink mx-1>
                        <span style="font-weight: bold">รับทราบ</span>
                      </v-flex>
                      <v-flex class="justify-end text-right" style="font-weight: bold">
                        เปลี่ยนชื่อเอกสาร
                      </v-flex>
                      <v-flex xs3></v-flex>
                    </v-layout>
                    <v-layout v-for="(fileInvestigator,
                      index) in fileList.fileInvestigator" :key="'C' + index">
                      <v-flex row ml-2 xs2>
                        <v-checkbox @click.native="
                          checkboxClick(
                            'informedFile',
                            'fileInvestigator',
                            fileInvestigator.value
                          )
                          " v-model="guaranteeFile.fileInvestigator" color="#3e7662" :value="fileInvestigator.value"
                          class="mx-1"></v-checkbox>
                        <v-checkbox @click.native="
                          checkboxClick(
                            'guaranteeFile',
                            'fileInvestigator',
                            fileInvestigator.value
                          )
                          " v-model="informedFile.fileInvestigator" color="#3e7662" :value="fileInvestigator.value"
                          class="mx-2"></v-checkbox>
                      </v-flex>
                      <v-flex xs6>
                        <a :href="fileInvestigator.path" style="color: #3e7662;" target="_blank">
                          <span class="d-flex mt-1">{{
                            fileInvestigator.fileName
                          }}</span>
                        </a>
                      </v-flex>
                      <v-flex>
                        <v-checkbox color="#3e7662" v-model="fileInvestigator.isChangeName" @click="
                          fileInvestigator.isChangeName
                            ? (fileInvestigator.newName =
                              fileInvestigator.newName)
                            : (fileInvestigator.newName = '')
                          "></v-checkbox>
                      </v-flex>
                      <v-flex ml-4>
                        <v-text-field color="#3e7662" :disabled="!fileInvestigator.isChangeName" outlined dense
                          v-model="fileInvestigator.newName" placeholder="ตั้งชื่อเอกสาร"></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout class="my-8 px-6">
                      <v-flex class="text-start">
                        <span style="font-weight: bold;font-size: 18px;">เอกสารอื่นๆ</span>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex shrink mx-1>
                        <span style="font-weight: bold">รับรอง</span>
                      </v-flex>
                      <v-flex shrink mx-1>
                        <span style="font-weight: bold">รับทราบ</span>
                      </v-flex>
                      <v-flex class="justify-end text-right" style="font-weight: bold">
                        เปลี่ยนชื่อเอกสาร
                      </v-flex>
                      <v-flex xs3></v-flex>
                    </v-layout>
                    <v-layout v-for="(fileOther, index) in fileList.fileOther" :key="'D' + index">
                      <v-flex row ml-2 xs2>
                        <v-checkbox @click.native="
                          checkboxClick(
                            'informedFile',
                            'fileOther',
                            fileOther.value
                          )
                          " v-model="guaranteeFile.fileOther" color="#3e7662" :value="fileOther.value"
                          class="mx-1"></v-checkbox>
                        <v-checkbox @click.native="
                          checkboxClick(
                            'guaranteeFile',
                            'fileOther',
                            fileOther.value
                          )
                          " v-model="informedFile.fileOther" color="#3e7662" :value="fileOther.value"
                          class="mx-2"></v-checkbox>
                      </v-flex>
                      <v-flex xs6>
                        <a :href="fileOther.path" style="color: #3e7662;" target="_blank">
                          <span class="d-flex mt-1">{{
                            fileOther.fileName
                          }}</span>
                        </a>
                      </v-flex>
                      <v-flex>
                        <v-checkbox color="#3e7662" v-model="fileOther.isChangeName" @click="
                          fileOther.isChangeName
                            ? (fileOther.newName = fileOther.newName)
                            : (fileOther.newName = '')
                          "></v-checkbox>
                      </v-flex>
                      <v-flex ml-4>
                        <v-text-field color="#3e7662" :disabled="!fileOther.isChangeName" outlined dense
                          v-model="fileOther.newName" placeholder="ตั้งชื่อเอกสาร"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>

                <v-layout v-if="filterType === '2'">
                  <v-flex>
                    <v-layout class="mt-4">
                      <v-flex>
                        <span class="font-weight-bold" style="font-size: 18px;">รายงานเหตุการณ์การไม่พึ่งประสงค์ (SAE
                          report)</span>
                      </v-flex>
                    </v-layout>
                    <v-layout class="mt-4">
                      <v-flex class="text-start pl-6">
                        <span class="font-weight-bold">ผลการพิจารณา</span>
                      </v-flex>
                    </v-layout>
                    <v-radio-group hide-details v-model="form.saeReport.hasResult" class="pl-12 mt-2">
                      <div class="mb-4 font-weight-bold">
                        <v-radio class="ml-3" color="#3E7662" label="รับทราบ" value="1" @click.native="clearSAE('1')" />
                      </div>
                      <div class="mb-4 font-weight-bold">
                        <v-radio class="ml-3" color="#3E7662" label="รับทราบโดยไม่มีการเปลี่ยนแปลงเอกสาร" value="2"
                          @click.native="clearSAE('2')" />
                      </div>
                      <div class="mb-4">
                        <div class="font-weight-bold">
                          <v-radio class="ml-3" color="#3E7662" label="รับทราบโดยต้องมีการเปลี่ยนเอกสาร" value="3"
                            @click.native="clearSAE('3')" />
                        </div>
                        <div class="mt-2">
                          <v-layout class="pl-7">
                            <v-flex class="text-start font-weight-bold pl-4 mt-n1">
                              <v-text-field placeholder="เขียนคำอธิบายตามรายงานประชุม"
                                :disabled="form.saeReport.hasResult !== '3'" color="#3E7662" dense hide-details
                                v-model="form.saeReport.gotItHaveChange" />
                            </v-flex>
                          </v-layout>
                        </div>
                      </div>
                      <div class="mb-4">
                        <div class="font-weight-bold">
                          <v-radio class="ml-3" color="#3E7662" label="รับทราบและดำเนินการตรวจเยี่ยม (sit visit)"
                            value="4" @click.native="clearSAE('4')" />
                        </div>
                        <div class="mt-2">
                          <v-layout class="pl-7">
                            <v-flex class="text-start font-weight-bold pl-4 mt-n1">
                              <v-text-field placeholder="เขียนคำอธิบายตามรายงานประชุม"
                                :disabled="form.saeReport.hasResult !== '4'" color="#3E7662" dense hide-details
                                v-model="form.saeReport.siteVisit" />
                            </v-flex>
                          </v-layout>
                        </div>
                      </div>
                      <div class="mb-4">
                        <div class="font-weight-bold">
                          <v-radio class="ml-3" color="#3E7662"
                            label="ระงับโครงการวิจัยชั่วคราว (suspension) หรือยุติโครงการ (termination)" value="5"
                            @click.native="clearSAE('5')" />
                        </div>
                        <div class="mt-2">
                          <v-layout class="pl-7">
                            <v-flex class="text-start font-weight-bold pl-4 mt-n1">
                              <v-text-field placeholder="เขียนคำอธิบายตามรายงานประชุม"
                                :disabled="form.saeReport.hasResult !== '5'" color="#3E7662" dense hide-details
                                v-model="form.saeReport.suspension" />
                            </v-flex>
                          </v-layout>
                        </div>
                      </div>
                    </v-radio-group>
                  </v-flex>
                </v-layout>

                <!-- รายงานการเบี่ยงเบนโครงร่างวิจัย (Deviation Report) -->
                <v-layout v-if="filterType === '3'">
                  <v-flex>
                    <v-layout class="mt-4">
                      <v-flex>
                        <span class="font-weight-bold" style="font-size: 18px;">
                          รายงานการเบี่ยงเบนโครงร่างวิจัย (Deviation Report)
                        </span>
                      </v-flex>
                    </v-layout>
                    <v-layout class="mt-4">
                      <v-flex class="text-start pl-6">
                        <span class="font-weight-bold">
                          ตอบรับรายงานการเบี่ยงเบนหรือไม่ปฏิบัติตามโครงร่างการวิจัยฯ
                        </span>
                      </v-flex>
                    </v-layout>
                    <v-radio-group hide-details v-model="form.deviationReport.hasResult" class="pl-12 mt-2">
                      <div class="mb-4">
                        <v-layout class="font-weight-bold">
                          <v-flex class="shrink pr-2 d-flex align-center">
                            <v-radio class="ml-3" color="#3E7662" label="รับทราบ" value="1"
                              @click.native="clearDeviation('1')" />
                          </v-flex>
                          <v-flex class="mt-n2">
                            <v-text-field :disabled="form.deviationReport.hasResult !== '1'" color="#3E7662" dense
                              hide-details v-model="form.deviationReport.demand" />
                          </v-flex>
                        </v-layout>
                      </div>
                      <div class="mb-4">
                        <v-layout class="font-weight-bold">
                          <v-flex class="shrink pr-2 d-flex align-center">
                            <v-radio class="ml-3" color="#3E7662" label="ขอแนะนำให้ท่าน" value="2"
                              @click.native="clearDeviation('2')" />
                          </v-flex>
                          <v-flex class="mt-n2">
                            <v-text-field :disabled="form.deviationReport.hasResult !== '2'" color="#3E7662" dense
                              hide-details v-model="form.deviationReport.recommend" />
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-radio-group>
                  </v-flex>
                </v-layout>

                <div v-if="filterType === '4'">
                  <v-divider class="my-6"></v-divider>

                  <v-layout class="mt-6 px-6">
                    <v-flex class="text-start">
                      <span style="font-weight: bold;font-size: 18px;">ประเภทการพิจารณา</span>
                    </v-flex>
                  </v-layout>
                  <v-layout class="px-6 mt-2">
                    <v-flex>
                      <v-radio-group hide-details v-model="form.considerationType" row>
                        <v-radio color="#3E7662" label="รายงานความก้าวหน้า" value="0" @click="clearDateApprove"></v-radio>
                        <v-radio color="#3E7662" label="ต่ออายุโครงการ" value="1"></v-radio>
                      </v-radio-group>
                    </v-flex>
                  </v-layout>
                </div>

                <!-- Progress Report -->
                <v-layout v-if="filterType === '4'" class="pt-6">
                  <v-flex>
                    <v-layout>
                      <v-flex>
                        <span class="font-weight-bold" style="font-size: 18px;">รายงานความก้าวหน้าและขอต่ออายุโครงการวิจัย
                          (Progress
                          Report)</span>
                      </v-flex>
                    </v-layout>
                    <v-layout class="mt-4 pl-12">
                      <v-flex>
                        <v-radio-group hide-details v-model="form.progressReport.hasResult">
                          <div class="mb-4">
                            <div class="font-weight-bold">
                              <v-radio class="ml-3" color="#3E7662" label="รับรอง (approval)" value="1"
                                @click.native="clear('1')" />
                            </div>
                            <!--<div class="mt-2">-->
                            <!--<v-layout class="pl-12">-->
                            <!--<v-flex class="shrink text-star align-center d-flex">-->
                            <!--<span>ความถี่ในการส่งรางานความก้าวหน้า</span>-->
                            <!--</v-flex>-->
                            <!--<v-flex xs2 class="text-start font-weight-bold pl-4 mt-n1 text-field-center">-->
                            <!--<v-text-field-->
                            <!--type="number"-->
                            <!--:disabled="form.progressReport.hasResult !== '1'"-->
                            <!--color="#3E7662" dense hide-details-->
                            <!--v-model="form.progressReport.frequency"-->
                            <!--/>-->
                            <!--</v-flex>-->
                            <!--<v-flex class="ml-4">-->
                            <!--<span>เดือน</span>-->
                            <!--</v-flex>-->
                            <!--</v-layout>-->
                            <!--</div>-->
                          </div>

                          <div class="mb-4">
                            <div class="font-weight-bold">
                              <v-radio class="ml-3" color="#3E7662"
                                label="รับรองภายหลังการปรับปรุงแก้ไข หรือภายหลังได้รับข้อมูลเพิ่มเติม" value="2"
                                @click.native="clear('2')" />
                            </div>
                            <div class="mt-2">
                              <v-layout class="pl-7">
                                <v-flex class="text-start font-weight-bold pl-4 mt-n1">
                                  <v-text-field placeholder="เขียนคำอธิบายตามข้อเสนอแนะมติที่ประชุมฯ" :disabled="form.progressReport.hasResult !== '2'
                                    " color="#3E7662" dense hide-details v-model="form.progressReport.afterEdit" />
                                </v-flex>
                              </v-layout>
                            </div>
                          </div>

                          <div class="mb-4">
                            <div class="font-weight-bold">
                              <v-radio class="ml-3" color="#3E7662" label="หยุดการรับรองชั่วคราว (suspension)" value="3"
                                @click.native="clear('3')" />
                            </div>
                            <div class="mt-2">
                              <v-layout class="pl-7">
                                <v-flex class="text-start font-weight-bold pl-4 mt-n1">
                                  <v-text-field placeholder="เขียนคำอธิบายตามข้อเสนอแนะมติที่ประชุมฯ" :disabled="form.progressReport.hasResult !== '3'
                                    " color="#3E7662" dense hide-details v-model="form.progressReport.suspension" />
                                </v-flex>
                              </v-layout>
                            </div>
                          </div>

                          <div class="mb-4">
                            <div class="font-weight-bold">
                              <v-radio class="ml-3" color="#3E7662" label="ยุติการรับรอง (termination)" value="4"
                                @click.native="clear('4')" />
                            </div>
                            <div class="mt-2">
                              <v-layout class="pl-7">
                                <v-flex class="text-start font-weight-bold pl-4 mt-n1">
                                  <v-text-field placeholder="เขียนคำอธิบายตามข้อเสนอแนะมติที่ประชุมฯ" :disabled="form.progressReport.hasResult !== '4'
                                    " color="#3E7662" dense hide-details v-model="form.progressReport.termination" />
                                </v-flex>
                              </v-layout>
                            </div>
                          </div>
                        </v-radio-group>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>

                <!-- รายงานสรุปผลการวิจัย (Final Report) -->
                <v-layout v-if="filterType === '5'">
                  <v-flex>
                    <v-layout class="mt-4">
                      <v-flex>
                        <span class="font-weight-bold" style="font-size: 18px;">
                          รายงานสรุปผลการวิจัย (Final Report)
                        </span>
                      </v-flex>
                    </v-layout>
                    <v-layout class="mt-4">
                      <v-flex class="text-start pl-6">
                        <span class="font-weight-bold">
                          ตอบรับรายงานสรุปผลการวิจัย
                        </span>
                      </v-flex>
                    </v-layout>
                    <v-radio-group hide-details v-model="form.finalReport.hasResult" class="pl-12 mt-2">
                      <div class="mb-4">
                        <v-layout class="font-weight-bold">
                          <v-flex class="shrink pr-2 d-flex align-center">
                            <v-radio class="ml-3" color="#3E7662" label="รับทราบ" value="1"
                              @click.native="clearDeviation('1')" />
                          </v-flex>
                        </v-layout>
                      </div>
                      <div class="mb-4">
                        <v-layout class="font-weight-bold">
                          <v-flex class="shrink pr-2 d-flex align-center">
                            <v-radio class="ml-3" color="#3E7662" label="รับทราบ และมีข้อแนะนำ" value="2"
                              @click.native="clearDeviation('2')" />
                          </v-flex>
                          <v-flex class="mt-n2">
                            <v-text-field placeholder="เขียนคำอธิบายตามรายงานประชุม"
                              :disabled="form.finalReport.hasResult !== '2'" color="#3E7662" dense hide-details
                              v-model="form.finalReport.explain" />
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-radio-group>
                  </v-flex>
                </v-layout>

                <!-- แจ้งปิดโครงการวิจัยก่อนกำหนด (Terminate) -->
                <v-layout v-if="filterType === '7'">
                  <v-flex>
                    <v-layout class="mt-4">
                      <v-flex>
                        <span class="font-weight-bold" style="font-size: 18px;">
                          แจ้งปิดโครงการวิจัยก่อนกำหนด (Terminate)
                        </span>
                      </v-flex>
                    </v-layout>
                    <v-layout class="mt-4">
                      <v-flex class="text-start pl-6">
                        <span class="font-weight-bold">
                          ตอบรับรายงานการยุติโครงการวิจัยก่อนกำหนด
                        </span>
                      </v-flex>
                    </v-layout>
                    <v-radio-group hide-details v-model="form.terminationReport.hasResult" class="pl-12 mt-2">
                      <div class="mb-4">
                        <v-layout class="font-weight-bold">
                          <v-flex class="shrink pr-2 d-flex align-center">
                            <v-radio class="ml-3" color="#3E7662" label="ขอทราบ" value="1"
                              @click.native="clearTermination('1')" />
                          </v-flex>
                          <v-flex class="mt-n2">
                            <v-text-field :disabled="form.terminationReport.hasResult !== '1'
                              " color="#3E7662" dense hide-details v-model="form.terminationReport.demand" />
                          </v-flex>
                        </v-layout>
                      </div>
                      <div class="mb-4">
                        <v-layout class="font-weight-bold">
                          <v-flex class="shrink pr-2 d-flex align-center">
                            <v-radio class="ml-3" color="#3E7662" label="ขอแนะนำให้ท่าน" value="2"
                              @click.native="clearTermination('2')" />
                          </v-flex>
                          <v-flex class="mt-n2">
                            <v-text-field :disabled="form.terminationReport.hasResult !== '2'
                              " color="#3E7662" dense hide-details v-model="form.terminationReport.recommend" />
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-radio-group>
                  </v-flex>
                </v-layout>

                <!-- รายงานเหตุการณ์การไม่พึ่งประสงค์จากยา (Adverse Drug Reaction Report) -->
                <v-layout v-if="filterType === '8'">
                  <v-flex>
                    <v-layout class="mt-4">
                      <v-flex>
                        <span class="font-weight-bold" style="font-size: 18px;">
                          รายงานเหตุการณ์การไม่พึ่งประสงค์จากยา (Adverse Drug
                          Reaction Report)
                        </span>
                      </v-flex>
                    </v-layout>
                    <v-layout class="mt-4">
                      <v-flex class="text-start pl-6">
                        <span class="font-weight-bold">ผลการพิจารณา</span>
                      </v-flex>
                    </v-layout>
                    <v-radio-group hide-details v-model="form.adverseDrug.hasResult" class="pl-12 mt-2">
                      <div class="mb-4 font-weight-bold">
                        <v-radio class="ml-3" color="#3E7662" label="รับทราบ" value="1"
                          @click.native="clearAdverseDrug('1')" />
                      </div>
                      <div class="mb-4 font-weight-bold">
                        <v-radio class="ml-3" color="#3E7662" label="รับทราบโดยไม่มีการเปลี่ยนแปลงเอกสาร" value="2"
                          @click.native="clearAdverseDrug('2')" />
                      </div>
                      <div class="mb-4">
                        <div class="font-weight-bold">
                          <v-radio class="ml-3" color="#3E7662" label="รับทราบโดยต้องมีการเปลี่ยนเอกสาร" value="3"
                            @click.native="clearAdverseDrug('3')" />
                        </div>
                        <div class="mt-2">
                          <v-layout class="pl-12">
                            <v-flex class="text-start font-weight-bold pl-4 mt-n1">
                              <v-text-field placeholder="เขียนคำอธิบายตามรายงานประชุม"
                                :disabled="form.adverseDrug.hasResult !== '3'" color="#3E7662" dense hide-details
                                v-model="form.adverseDrug.gotItHaveChange" />
                            </v-flex>
                          </v-layout>
                        </div>
                      </div>
                      <div class="mb-4">
                        <div class="font-weight-bold">
                          <v-radio class="ml-3" color="#3E7662" label="รับทราบและดำเนินการตรวจเยี่ยม (sit visit)"
                            value="4" @click.native="clearAdverseDrug('4')" />
                        </div>
                        <div class="mt-2">
                          <v-layout class="pl-12">
                            <v-flex class="text-start font-weight-bold pl-4 mt-n1">
                              <v-text-field placeholder="เขียนคำอธิบายตามรายงานประชุม"
                                :disabled="form.adverseDrug.hasResult !== '4'" color="#3E7662" dense hide-details
                                v-model="form.adverseDrug.siteVisit" />
                            </v-flex>
                          </v-layout>
                        </div>
                      </div>
                      <div class="mb-4">
                        <div class="font-weight-bold">
                          <v-radio class="ml-3" color="#3E7662"
                            label="ระงับโครงการวิจัยชั่วคราว (suspension) หรือยุติโครงการ (termination)" value="5"
                            @click.native="clearAdverseDrug('5')" />
                        </div>
                        <div class="mt-2">
                          <v-layout class="pl-12">
                            <v-flex class="text-start font-weight-bold pl-4 mt-n1">
                              <v-text-field placeholder="เขียนคำอธิบายตามรายงานประชุม"
                                :disabled="form.adverseDrug.hasResult !== '5'" color="#3E7662" dense hide-details
                                v-model="form.adverseDrug.suspension" />
                            </v-flex>
                          </v-layout>
                        </div>
                      </div>
                    </v-radio-group>
                  </v-flex>
                </v-layout>

                <div v-if="filterType === '4'">
                  <div v-if="form.considerationType === '0'">
                    <v-layout class="mt-8 px-6">
                      <v-flex class="text-start">
                        <span style="font-weight: bold;font-size: 18px;">กำหนดการอนุมัติเอกสาร</span>
                      </v-flex>
                    </v-layout>
                    <v-layout class="px-6">
                      <v-flex justify-start align-center d-flex>
                        <DateInputForm :model="progressReportDateShow" @update-data="
                          updateDate('progressReportDate', $event)
                          ">
                        </DateInputForm>
                      </v-flex>
                    </v-layout>
                  </div>

                  <div v-if="form.considerationType === '1'">
                    <!-- <div v-if="$moment(new Date()) > new Date(approvalExpireDate)"> -->
                      <v-layout class="mt-8 px-6">
                        <v-flex class="text-start">
                          <span style="font-weight: bold;font-size: 18px;">วันที่อนุมัติเอกสารครั้งล่าสุด</span>
                        </v-flex>
                      </v-layout>
                      <v-layout class="px-6">
                        <v-flex justify-start align-center d-flex>
                          <DateInputForm :model="projectRenewalDateShow" @update-data="
                            updateDate('projectRenewalDate', $event)
                            ">
                          </DateInputForm>
                        </v-flex>
                      </v-layout>
                    <!-- </div> -->

                    <!-- <div v-else>
                      <v-layout class="mt-8 px-6">
                        <v-flex class="text-start">
                          <span style="font-weight: bold;font-size: 18px;">วันที่อนุมัติเอกสารครั้งล่าสุด</span>
                        </v-flex>
                      </v-layout>
                      <v-layout class="px-6">
                        <v-flex justify-start align-center d-flex>
                          <TextfieldForm readonly :model="changeDate(projectRenewalDate)">
                          </TextfieldForm>
                        </v-flex>
                      </v-layout>
                    </div> -->

                    <v-layout class="mt-8 px-6">
                      <v-flex class="text-start">
                        <span style="font-weight: bold;font-size: 18px;">กำหนดการส่งรายงานความก้าวหน้า</span>
                      </v-flex>
                    </v-layout>
                    <v-layout class="px-6">
                      <v-flex justify-start align-center d-flex>
                        <v-radio-group hide-details v-model="form.month">
                          <v-row>
                            <v-col cols="auto">
                              <v-radio @click.native="checkRadioModal('1')" :class="checkRadio1 ? 'radio-checked' : ''"
                                color="#3E7662" label="6 เดือน" value="6"></v-radio>
                            </v-col>
                            <v-col cols="auto">
                              <v-radio @click.native="checkRadioModal('2')" :class="checkRadio2 ? 'radio-checked' : ''"
                                color="#3E7662" label="1 ปี" value="12"></v-radio>
                            </v-col>
                            <v-col cols="auto">
                              <v-radio @click.native="checkRadioModal('3')" :class="checkRadio3 ? 'radio-checked' : ''"
                                color="#3E7662" label="อื่นๆ ระบุ" value="other"></v-radio>
                            </v-col>
                            <v-col cols="2" class="text-field-center">
                              <v-text-field type="number" :disabled="form.month !== 'other'" color="#3E7662" class="mt-n5"
                                v-model="form.otherMonth" hide-details />
                            </v-col>
                            <v-col cols="auto">
                              <span class="font-weight-bold">เดือน</span>
                            </v-col>
                          </v-row>
                        </v-radio-group>
                      </v-flex>
                    </v-layout>
                  </div>
                </div>

                <div v-else>
                  <v-layout class="mt-8 px-6">
                    <v-flex class="text-start">
                      <span style="font-weight: bold;font-size: 18px;">กำหนดการอนุมัติเอกสาร</span>
                    </v-flex>
                  </v-layout>
                  <v-layout class="px-6">
                    <v-flex justify-start align-center d-flex>
                      <DateInputForm :model="approvalDate" @update-data="updateDate('approvalDate', $event)">
                      </DateInputForm>
                    </v-flex>
                  </v-layout>
                </div>
              </div>

              <div v-if="form.status === 'ปรับปรุงแก้ไขเพื่อพิจารณาใหม่'">
                <v-divider class="my-6"></v-divider>

                <v-layout class="mt-8 px-6">
                  <v-flex class="text-start">
                    <span style="font-weight: bold;font-size: 18px;">NOTE</span>
                  </v-flex>
                </v-layout>
                <v-layout class="px-6">
                  <v-flex justify-start align-center d-flex>
                    <v-textarea outlined dense solo flat rows="5" background-color="#FBF6F3" item-color="#3E7662"
                      color="#3E7662" v-model="form.note"></v-textarea>
                  </v-flex>
                </v-layout>

                <v-layout class="mt-8 px-6">
                  <v-flex class="text-start">
                    <span style="font-weight: bold;font-size: 18px;">ไฟล์แนบ
                    </span>
                    <span style="font-size: 14px;color: red">*ใช้สกุลไฟล์ PDF เท่านั้น</span>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex justify-start align-center d-flex>
                    <v-layout px-12 mt-4>
                      <v-flex d-flex justify-start align-center style="text-align: left;font-weight: bold">
                        <v-file-input accept=".pdf" prepend-icon="" hide-details v-model="form.file"
                          label="กรุณาเลือกไฟล์ PDF" outlined dense color="#3E7662" clearable background-color="#FBF6F3"
                          append-icon="attach_file"></v-file-input>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </div>
            </v-card-text>

            <!--                        <pre class="warning text-start">{{form}}</pre>-->
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn style="font-weight: bold" color="#3E7662" text @click="dialog = false">ยกเลิก
              </v-btn>
              <v-btn style="font-weight: bold" color="#3E7662" text @click="update">บันทึก
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <!-- Modal View To Reviewer Files -->
    <template>
      <v-row justify="center">
        <v-dialog v-model="viewFileDialog" persistent width="800px" max-width="80%">
          <v-card>
            <!-- Header -->
            <v-card-title class="mb-4 justify-center" style="background-color: #3e7662;color: white;">
              <span class="font-weight-medium font-weight-bold">ดูเอกสารแนบ</span>
            </v-card-title>
            <v-card-text class="justify-center" v-if="corresFile">
              <v-layout>
                <h2 style="margin: auto">
                  เอกสาร Correspondence
                </h2>
              </v-layout>
              <v-layout my-6>
                <v-flex>
                  <a :href="corresFile.file" style="color: #3e7662;" target="_blank">
                    <p style="font-size: 16px;text-align: center" class="my-2">
                      {{ corresFile.title ? corresFile.title : "ไม่มีชื่อ" }}
                    </p>
                  </a>
                </v-flex>
              </v-layout>
              <div v-if="corresOtherFile.length > 1" class="my-6">
                <v-layout>
                  <h2 style="margin: auto" class="mb-6">
                    เอกสาร อื่นๆ
                  </h2>
                </v-layout>
                <v-layout v-for="(file, k) in corresOtherFile" :key="k">
                  <v-flex ml-2 justify-center>
                    <a :href="file.filePath" style="color: #3e7662;" target="_blank">
                      <p style="font-size: 16px;text-align: center" class="my-2">
                        {{ file.title ? file.title : "ไม่มีชื่อ" }}
                      </p>
                    </a>
                  </v-flex>
                </v-layout>
              </div>
              <div v-else>
                <v-layout>
                  <v-flex my-12>
                    <p style="font-size: 18px;font-weight: bold; color: #3e7662;text-align: center">
                      ไม่พบเอกสารแนบ
                    </p>
                  </v-flex>
                </v-layout>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn style="font-weight: bold" color="#3E7662" text @click="viewFileDialog = false">
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <loading color="#527281" :active.sync="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>
  </v-content>
</template>

<script>
import FormTable from "../../components/table/FormTable";
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import { mapState } from "vuex";
import TextAutocomplete from "../../components/input/TextAutocomplete";
import TextfieldForm from "../../components/input/TextfieldForm";
import TextareaForm from "../../components/input/TextareaForm";
import DateInputForm from "../../components/input/DateInputForm";

export default {
  name: "Meeting",
  components: {
    TextAutocomplete,
    TextareaForm,
    TextfieldForm,
    FormTable,
    DateInputForm,
    Loading,
  },
  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
    }),
  },
  data: () => ({
    filterType: "1",
    checkRadio1: true,
    checkRadio2: false,
    checkRadio3: false,
    checkRadio4: false,
    checkRadio5: false,
    checkRadio6: false,
    checkRadio7: false,
    checkRadio8: false,
    checkRadio9: false,
    meetingDialog: false,
    viewFileDialog: false,
    isLoading: false,
    fullPage: true,
    paginate: {
      current_page: 1,
      from: 1,
      last_page: 1,
      per_page: 1,
      total: 1,
      to: 1,
    },
    headers: [
      {
        text: "ลำดับ",
        value: "number",
        align: "center",
        sortable: false,
        width: "5%",
      },
      {
        text: "ชื่องานวิจัย",
        value: "nameResearch",
        align: "center",
        sortable: false,
      },
      {
        text: "รหัสโครงการ",
        value: "researchCode",
        align: "center",
        sortable: false,
      },
      {
        text: "ชื่อนักวิจัย",
        value: "researcherName",
        align: "center",
        sortable: false,
        width: "10%",
      },
      {
        text: "เรื่องที่",
        value: "group_id",
        align: "center",
        sortable: false,
        width: "5%",
      },
      {
        text: "version",
        value: "version",
        align: "center",
        sortable: false,
        width: "5%",
      },
      {
        text: "สถานะ",
        value: "status",
        align: "center",
        sortable: false,
        width: "10%",
      },
      {
        text: "เลขรับ(Initial)",
        value: "initial",
        align: "center",
        sortable: false,
        width: "10%",
      },
      {
        text: "ดูแบบฟอร์ม",
        value: "viewOutline",
        align: "center",
        sortable: false,
        width: "10%",
      },
      {
        text: "ดูเอกสารประเมิน",
        value: "viewRfForm",
        align: "center",
        sortable: false,
        width: "10%",
      },
      {
        text: "ผลการพิจารณา",
        value: "verify",
        align: "center",
        sortable: false,
        width: "10%",
      },
    ],
    listRF: [],
    dialog: false,
    form: {
      progressReport: {
        hasResult: false,
        afterEdit: "",
        suspension: "",
        termination: "",
        frequency: "",
      },
      saeReport: {
        hasResult: false,
        gotItHaveChange: "",
        siteVisit: "",
        suspension: "",
      },
      adverseDrug: {
        hasResult: false,
        gotItHaveChange: "",
        siteVisit: "",
        suspension: "",
      },
      deviationReport: {
        hasResult: false,
        demand: "",
        recommend: "",
      },
      finalReport: {
        hasResult: false,
        explain: "",
      },
      terminationReport: {
        hasResult: false,
        demand: "",
        recommend: "",
      },
      id: "",
      name: "",
      filter: "",
      status: "",
      note: "",
      approveDate: "",
      month: "",
      otherMonth: "",
      considerationType: "",
      researchID: "",
      file: "",
    },
    approvalDate: "",
    verifyList: [
      { id: 1, name: "ผ่านการพิจารณา" },
      { id: 3, name: "ปรับปรุงแก้ไขเพื่อพิจารณาใหม่" },
    ],
    countRF12: 0,
    countRF05: 0,
    countCorres: 0,
    countRF03: 0,
    countRF04_1: 0,
    countRF04_2: 0,
    countRF06: 0,
    countRF07: 0,
    countSusar: 0,
    progressReportDate: "",
    progressReportDateShow: "",
    projectRenewalDate: "",
    projectRenewalDateShow: "",
    approvalExpireDate: "",
    fileList: {
      fileInformationSheet: [],
      fileInvestigator: [],
      fileProtocolModify: [],
      fileOther: [],
    },
    searchData: {
      researchCode: '',
      researcherName: '',
      filterType: 0
    },
    informedFile: {
      fileOther: [],
      fileInformationSheet: [],
      fileInvestigator: [],
      fileProtocolModify: [],
    },
    guaranteeFile: {
      fileOther: [],
      fileInformationSheet: [],
      fileInvestigator: [],
      fileProtocolModify: [],
    },
    corresOtherFile: [],
    corresFile: { file: '', title: '' },
  }),
  created() {
    this.getRFAll(1);
  },
  mounted() {
    // this.getRFAll(1);
  },
  methods: {
    checkboxClick(checkboxName, fileName, value) {
      let index = this[checkboxName][fileName].indexOf(value);
      if (index > -1) {
        this[checkboxName][fileName].splice(index, 1);
      }
    },
    checkRadioModal(name) {
      if (name === "1") {
        this.checkRadio1 = true;
        this.checkRadio2 = false;
        this.checkRadio3 = false;
        this.form.otherMonth = "";
      }
      if (name === "2") {
        this.checkRadio1 = false;
        this.checkRadio2 = true;
        this.checkRadio3 = false;
        this.form.otherMonth = "";
      }
      if (name === "3") {
        this.checkRadio1 = false;
        this.checkRadio2 = false;
        this.checkRadio3 = true;
        // this.filterType = '3';
      }
    },
    updateData(name, val) {
      this.form[name] = val;
    },
    getRFAll(page) {
      this.isLoading = true;
      this.listRF = [];
      let data = {
        page: page,
        filter: this.filterType,
        researchCode: this.searchData.researchCode,
        researcherName: this.searchData.researcherName,
      };
      this.$store.dispatch("FormRF/getRFAll", data).then((res) => {
        this.countRF12 = res.ResearchAmendmentCount;
        this.countRF04_1 = res.AdverseEventCount;
        this.countRF05 = res.DeviationReportCount;
        this.countRF03 = res.ProgressReportCount;
        this.countRF06 = res.ResearchSummarizeCount;
        this.countRF07 = res.ResearchTerminationCount;
        this.countRF04_2 = res.AdverseDrugEventCount;
        this.countCorres = res.CorrespondenceCount;
        this.countSusar = res.FormSusarCount;
        let i = 1;
        res.data.data.forEach((data) => {
          console.log(data);
          this.listRF.push({
            number: i,
            id: data.id,
            researchID: data.researchID,
            nameResearch: data.research.thResearchName,
            researchCode: data.research.researchCode,
            researcherName: data.research.user.thName,
            group_id: data.group_id + 1,
            version: data.version,
            status: data.status,
            isRead: data.isRead,
            otherFile: data.otherFile,
            corresFile: data.file,
            corresName: data.name,
            filterType: this.filterType,
            initial: data.initialNumber,
            linkEdit: this.checkLink(),
            onView: 9,
            item: data,
            filter: this.filterType,
            userID: this.$route.query.id,
            idReport: data.researchID ? data.researchID : "-",
            evaluation:
              this.filterType == 1
                ? "FormRO05"
                : "" || this.filterType == 2
                  ? "FormRO07"
                  : "" || this.filterType == 3
                    ? "FormRO08"
                    : "" || this.filterType == 4
                      ? "FormRO06"
                      : "" || this.filterType == 5
                        ? "FormRO09"
                        : "" || this.filterType == 6
                          ? "FormRO19"
                          : "" || this.filterType == 7
                            ? "FormRO10"
                            : "" || this.filterType == 8
                              ? "FormRO07"
                              : "" || this.filterType == 9
                                ? "FormRFSusar"
                                : "",
            rfID: data.id,
            // this.filterType == 1 ? data.r_o05 !== null ? data.r_o05.researchAmendmentID : '' : '' ||
            // this.filterType == 2 ? data.r_o07 !== null ? data.r_o07.adverseEventID : '' : '' ||
            // this.filterType == 3 ? data.r_o08 !== null ? data.r_o08.deviationID : '' : '' ||
            // this.filterType == 4 ? data.r_o06 !== null ? data.r_o06.progressReportID : '' : '' ||
            // this.filterType == 5 ? data.r_o09 !== null ? data.r_o09.finalReportID : '' : '' ||
            // this.filterType == 7 ? data.r_o10 !== null ? data.r_o10.terminationReportID : '' : '' ||
            // this.filterType == 8 ? data.r_o07 !== null ? data.r_o07.adverseDrugID : '' : '',
          });
          i++;
        });
        this.paginate.current_page = res.data.current_page;
        this.paginate.from = res.data.from;
        this.paginate.last_page = res.data.last_page;
        this.paginate.per_page = res.data.per_page;
        this.paginate.total = res.data.total;
        this.paginate.to = res.data.to;
        this.isLoading = false;
      });
    },
    viewCorresFile(item) {
      console.log('item', item);
      this.viewFileDialog = true;
      this.corresOtherFile = item.otherFile;
      this.corresFile.file = item.corresFile;
      this.corresFile.title = item.corresName;
      console.log('corresotherFile', this.corresOtherFile);
      console.log('corresfIle', this.corresFile);
    },
    checkLink() {
      if (this.filterType === "1") {
        return "ViewFormRF12";
      }
      if (this.filterType === "2") {
        return "ViewFormRF04_2";
      }
      if (this.filterType === "3") {
        return "ViewFormRF05";
      }
      if (this.filterType === "4") {
        return "ViewFormRF03";
      }
      if (this.filterType === "5") {
        return "ViewFormRF06";
      }
      if (this.filterType === "7") {
        return "ViewFormRF07";
      }
      if (this.filterType === "8") {
        return "ViewFormRF04_1";
      }
      if (this.filterType === "9") {
        return "ViewFormRFSusar";
      }
    },
    checkRadio(name) {
      if (name === "1") {
        this.checkRadio1 = true;
        this.checkRadio2 = false;
        this.checkRadio3 = false;
        this.checkRadio4 = false;
        this.checkRadio5 = false;
        this.checkRadio6 = false;
        this.checkRadio7 = false;
        this.checkRadio8 = false;
        this.checkRadio9 = false;
      }
      if (name === "2") {
        this.checkRadio1 = false;
        this.checkRadio2 = true;
        this.checkRadio3 = false;
        this.checkRadio4 = false;
        this.checkRadio5 = false;
        this.checkRadio6 = false;
        this.checkRadio7 = false;
        this.checkRadio8 = false;
        this.checkRadio9 = false;
      }
      if (name === "3") {
        this.checkRadio1 = false;
        this.checkRadio2 = false;
        this.checkRadio3 = true;
        this.checkRadio4 = false;
        this.checkRadio5 = false;
        this.checkRadio6 = false;
        this.checkRadio7 = false;
        this.checkRadio8 = false;
        this.checkRadio9 = false;
      }
      if (name === "4") {
        this.checkRadio1 = false;
        this.checkRadio2 = false;
        this.checkRadio3 = false;
        this.checkRadio4 = true;
        this.checkRadio5 = false;
        this.checkRadio6 = false;
        this.checkRadio7 = false;
        this.checkRadio8 = false;
        this.checkRadio9 = false;
      }
      if (name === "5") {
        this.checkRadio1 = false;
        this.checkRadio2 = false;
        this.checkRadio3 = false;
        this.checkRadio4 = false;
        this.checkRadio5 = true;
        this.checkRadio6 = false;
        this.checkRadio7 = false;
        this.checkRadio8 = false;
        this.checkRadio9 = false;
      }
      if (name === "6") {
        this.checkRadio1 = false;
        this.checkRadio2 = false;
        this.checkRadio3 = false;
        this.checkRadio4 = false;
        this.checkRadio5 = false;
        this.checkRadio6 = true;
        this.checkRadio7 = false;
        this.checkRadio8 = false;
        this.checkRadio9 = false;
      }
      if (name === "7") {
        this.checkRadio1 = false;
        this.checkRadio2 = false;
        this.checkRadio3 = false;
        this.checkRadio4 = false;
        this.checkRadio5 = false;
        this.checkRadio6 = false;
        this.checkRadio7 = true;
        this.checkRadio8 = false;
        this.checkRadio9 = false;
      }
      if (name === "8") {
        this.checkRadio1 = false;
        this.checkRadio2 = false;
        this.checkRadio3 = false;
        this.checkRadio4 = false;
        this.checkRadio5 = false;
        this.checkRadio6 = false;
        this.checkRadio7 = false;
        this.checkRadio8 = true;
        this.checkRadio9 = false;
      }
      if (name === "9") {
        this.checkRadio1 = false;
        this.checkRadio2 = false;
        this.checkRadio3 = false;
        this.checkRadio4 = false;
        this.checkRadio5 = false;
        this.checkRadio6 = false;
        this.checkRadio7 = false;
        this.checkRadio8 = false;
        this.checkRadio9 = true;
      }
      this.getRFAll(1);
    },
    update() {
      if (
        this.filterType === "4" &&
        this.form.considerationType === "0" &&
        this.progressReportDate === ""
      ) {
        Swal.fire({
          title: "เกิดข้อผิดพลาด",
          text: "กรุณากรอกข้อมูลให้ครบ",
          icon: "warning",
          confirmButtonColor: "#3E7662",
        });
      } else if (
        this.filterType === "4" &&
        this.form.considerationType === "1" &&
        (this.projectRenewalDate === "" || this.form.month === "")
      ) {
        Swal.fire({
          title: "เกิดข้อผิดพลาด",
          text: "กรุณากรอกข้อมูลให้ครบ",
          icon: "warning",
          confirmButtonColor: "#3E7662",
        });
      } else {
        Swal.fire({
          title: "คุณต้องการอัพเดทผลการพิจารณาหรือไม่?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3E7662",
          cancelButtonColor: "rgb(189, 189, 189)",
          confirmButtonText: "ต้องการ",
          cancelButtonText: "ยกเลิก",
        }).then((result) => {
          if (result.value) {
            this.isLoading = true;
            if (this.form.considerationType === "0") {
              this.form.approveDate = this.progressReportDate;
            }
            if (this.form.status === "ผ่านการพิจารณา") {
              this.reName();
              this.$store
                .dispatch("FormRF/updateStatusRF2", this.form)
                .then((res) => {
                  this.isLoading = false;
                  Swal.fire({
                    title: "บันทึกเรียบร้อยแล้ว",
                    icon: "success",
                    position: "center",
                    showConfirmButton: false,
                    timer: 1500,
                  }).then(() => {
                    this.form.type = "";
                    this.form.month = "";
                    this.form.otherMonth = "";
                    this.form.approveDate = "";
                    this.progressReportDate = "";
                    this.progressReportDateShow = "";
                    this.projectRenewalDate = "";
                    this.projectRenewalDateShow = "";
                    this.approvalExpireDate = "";
                    this.form.informedFile = "";
                    this.form.guaranteeFile = "";
                    this.getRFAll(1);
                    this.dialog = false;
                  });
                })
                .catch((e) => {
                  this.isLoading = false;
                  Swal.fire({
                    title: "เกิดข้อผิดพลาด",
                    text: "บันทึกไม่สำเร็จ",
                    icon: "warning",
                    confirmButtonColor: "#3E7662",
                  });
                });
            } else {
              this.$store
                .dispatch("FormRF/updateStatusRF", this.form)
                .then((res) => {
                  this.isLoading = false;
                  Swal.fire({
                    title: "บันทึกเรียบร้อยแล้ว",
                    icon: "success",
                    position: "center",
                    showConfirmButton: false,
                    timer: 1500,
                  }).then(() => {
                    this.form.approveDate = "";
                    this.form.type = "";
                    this.form.month = "";
                    this.form.otherMonth = "";
                    this.progressReportDate = "";
                    this.progressReportDateShow = "";
                    this.projectRenewalDate = "";
                    this.projectRenewalDateShow = "";
                    this.approvalExpireDate = "";
                    this.getRFAll(1);
                    this.dialog = false;
                  });
                })
                .catch((e) => {
                  this.isLoading = false;
                  Swal.fire({
                    title: "เกิดข้อผิดพลาด",
                    text: "บันทึกไม่สำเร็จ",
                    icon: "warning",
                    confirmButtonColor: "#3E7662",
                  });
                });
            }
          }
        });
      }
    },
    verifyRF(val) {
      this.fileList = {
        fileInformationSheet: [],
        fileInvestigator: [],
        fileProtocolModify: [],
        fileOther: [],
      };
      this.informedFile = {
        fileInformationSheet: [],
        fileInvestigator: [],
        fileProtocolModify: [],
        fileOther: [],
      };
      this.guaranteeFile = {
        fileInformationSheet: [],
        fileInvestigator: [],
        fileProtocolModify: [],
        fileOther: [],
      };
      if (this.filterType === "4") {
        this.approvalExpireDate = val.research.approvalExpireDate;
        this.projectRenewalDate = val.research.approvalDate;
      }
      let docCount = 0;
      let fileOther;
      if (val.fileOther && Array.isArray(val.fileOther) && val.fileOther.length > 0) {
        if (val.fileOther.length > 0) {
          fileOther = val.fileOther
        } else {
          fileOther = JSON.parse(val.fileOther);
        }
        fileOther.forEach((doc) => {
          this.fileList.fileOther.push({
            value: docCount,
            version: doc.version,
            date: doc.date,
            fileName: doc.title ? doc.title : "ไม่มีชื่อ",
            path: doc.filePath,
            isChangeName: "",
            newName: "",
          });
          this.informedFile.fileOther.push(docCount);
          docCount++;
        });
      } else {
        this.fileList.fileOther = [];
      }

      docCount = 0;
      if (val.fileInformationSheet) {
        val.fileInformationSheet.forEach((doc) => {
          this.fileList.fileInformationSheet.push({
            value: docCount,
            version: doc.version,
            date: doc.date,
            fileName: doc.title ? doc.title : "ไม่มีชื่อ",
            path: doc.filePath,
            isChangeName: "",
            newName: "",
          });
          this.informedFile.fileInformationSheet.push(docCount);
          docCount++;
        });
      } else {
        this.fileList.fileInformationSheet = [];
      }
      docCount = 0;
      if (val.fileInvestigator) {
        val.fileInvestigator.forEach((doc) => {
          this.fileList.fileInvestigator.push({
            value: docCount,
            version: doc.version,
            date: doc.date,
            fileName: doc.title ? doc.title : "ไม่มีชื่อ",
            path: doc.filePath,
            isChangeName: "",
            newName: "",
          });
          this.informedFile.fileInvestigator.push(docCount);
          docCount++;
        });
      } else {
        this.fileList.fileInvestigator = [];
      }
      docCount = 0;
      if (val.fileProtocolModify) {
        val.fileProtocolModify.forEach((doc) => {
          this.fileList.fileProtocolModify.push({
            value: docCount,
            version: doc.version,
            date: doc.date,
            fileName: doc.title ? doc.title : "ไม่มีชื่อ",
            path: doc.filePath,
            isChangeName: "",
            newName: "",
          });
          this.informedFile.fileProtocolModify.push(docCount);
          docCount++;
        });
      } else {
        this.fileList.fileProtocolModify = [];
      }
      this.form.name = val.researchName;
      this.form.filter = this.filterType;
      this.form.status = val.status;
      this.form.id = val.id;
      this.form.researchID = val.researchID;
      this.dialog = true;
    },
    updateDate(name, val) {
      if (name === "approvalDate") {
        this.form.approveDate = val.date;
        this.approvalDate = this.changeDate(val.date);
      }
      if (name === "progressReportDate") {
        this.progressReportDate = val.date;
        this.progressReportDateShow = this.changeDate(val.date);
      }
      if (name === "projectRenewalDate") {
        this.projectRenewalDate = val.date;
        this.projectRenewalDateShow = this.changeDate(val.date);
      }
    },
    changeDate(val) {
      //change date start
      if (val) {
        let sub_year = val.substring(0, 4);
        let sub_month = val.substring(5, 7);
        let sub_day = val.substring(8, 10);

        sub_year = parseInt(sub_year) + 543;

        let changeDate = sub_day + "/" + sub_month + "/" + sub_year;
        return changeDate;
      } else {
        return "";
      }
    },
    clearForm() {
      this.form.approveDate = "";
      this.form.type = "";
      this.form.month = "";
      this.form.otherMonth = "";
    },
    clear(val) {
      if (val === "1") {
        this.form.progressReport.afterEdit = "";
        this.form.progressReport.suspension = "";
        this.form.progressReport.termination = "";
      }
      if (val === "2") {
        this.form.progressReport.frequency = "";
        this.form.progressReport.suspension = "";
        this.form.progressReport.termination = "";
      }
      if (val === "3") {
        this.form.progressReport.frequency = "";
        this.form.progressReport.afterEdit = "";
        this.form.progressReport.termination = "";
      }
      if (val === "4") {
        this.form.progressReport.frequency = "";
        this.form.progressReport.suspension = "";
        this.form.progressReport.afterEdit = "";
      }
    },
    clearSAE(val) {
      if (val === "1") {
        this.form.saeReport.gotItHaveChange = "";
        this.form.saeReport.siteVisit = "";
        this.form.saeReport.suspension = "";
      }
      if (val === "2") {
        this.form.saeReport.gotItHaveChange = "";
        this.form.saeReport.siteVisit = "";
        this.form.saeReport.suspension = "";
      }
      if (val === "3") {
        this.form.saeReport.siteVisit = "";
        this.form.saeReport.suspension = "";
      }
      if (val === "4") {
        this.form.saeReport.gotItHaveChange = "";
        this.form.saeReport.suspension = "";
      }
      if (val === "5") {
        this.form.saeReport.gotItHaveChange = "";
        this.form.saeReport.siteVisit = "";
      }
    },
    clearAdverseDrug(val) {
      if (val === "1") {
        this.form.adverseDrug.gotItHaveChange = "";
        this.form.adverseDrug.siteVisit = "";
        this.form.adverseDrug.suspension = "";
      }
      if (val === "2") {
        this.form.adverseDrug.gotItHaveChange = "";
        this.form.adverseDrug.siteVisit = "";
        this.form.adverseDrug.suspension = "";
      }
      if (val === "3") {
        this.form.adverseDrug.siteVisit = "";
        this.form.adverseDrug.suspension = "";
      }
      if (val === "4") {
        this.form.adverseDrug.gotItHaveChange = "";
        this.form.adverseDrug.suspension = "";
      }
      if (val === "5") {
        this.form.adverseDrug.gotItHaveChange = "";
        this.form.adverseDrug.siteVisit = "";
      }
    },
    clearDeviation(val) {
      if (val === "1") {
        this.form.deviationReport.recommend = "";
      }
      if (val === "2") {
        this.form.deviationReport.demand = "";
      }
    },
    clearTermination(val) {
      if (val === "1") {
        this.form.terminationReport.recommend = "";
      }
      if (val === "2") {
        this.form.terminationReport.demand = "";
      }
    },
    clearDateApprove() {
      this.approvalDate = "";
      this.form.approveDate = "";
    },
    reName() {
      this.fileList.fileInformationSheet.forEach((file) => {
        if (file.isChangeName === true) {
          let index = this.guaranteeFile.fileInformationSheet.indexOf(
            file.value
          );
          if (index > -1) {
            if (file.newName !== "")
              this.guaranteeFile.fileInformationSheet[index] =
                file.newName +
                " Version " +
                file.version +
                " Date " +
                file.date;
          } else {
            let index = this.informedFile.fileInformationSheet.indexOf(
              file.value
            );
            if (index > -1) {
              if (file.newName !== "")
                this.informedFile.fileInformationSheet[index] =
                  file.newName +
                  " Version " +
                  file.version +
                  " Date " +
                  file.date;
            }
          }
        }
      });
      this.fileList.fileProtocolModify.forEach((file) => {
        if (file.isChangeName === true) {
          let index = this.guaranteeFile.fileProtocolModify.indexOf(file.value);
          if (index > -1) {
            if (file.newName !== "")
              this.guaranteeFile.fileProtocolModify[index] =
                file.newName +
                " Version " +
                file.version +
                " Date " +
                file.date;
          } else {
            let index = this.informedFile.fileProtocolModify.indexOf(
              file.value
            );
            if (index > -1) {
              if (file.newName !== "")
                this.informedFile.fileProtocolModify[index] =
                  file.newName +
                  " Version " +
                  file.version +
                  " Date " +
                  file.date;
            }
          }
        }
      });
      this.fileList.fileInvestigator.forEach((file) => {
        if (file.isChangeName === true) {
          let index = this.guaranteeFile.fileInvestigator.indexOf(file.value);
          if (index > -1) {
            if (file.newName !== "")
              this.guaranteeFile.fileInvestigator[index] =
                file.newName +
                " Version " +
                file.version +
                " Date " +
                file.date;
          } else {
            let index = this.informedFile.fileInvestigator.indexOf(file.value);
            if (index > -1) {
              if (file.newName !== "")
                this.informedFile.fileInvestigator[index] =
                  file.newName +
                  " Version " +
                  file.version +
                  " Date " +
                  file.date;
            }
          }
        }
      });
      this.fileList.fileOther.forEach((file) => {
        if (file.isChangeName === true) {
          let index = this.guaranteeFile.fileOther.indexOf(file.value);
          if (index > -1) {
            if (file.newName !== "")
              this.guaranteeFile.fileOther[index] =
                file.newName +
                " Version " +
                file.version +
                " Date " +
                file.date;
          } else {
            let index = this.informedFile.fileOther.indexOf(file.value);
            if (index > -1) {
              if (file.newName !== "")
                this.informedFile.fileOther[index] =
                  file.newName +
                  " Version " +
                  file.version +
                  " Date " +
                  file.date;
            }
          }
        }
      });
      this.form.informedFile = this.informedFile;
      this.form.guaranteeFile = this.guaranteeFile;
    },
  },
};
</script>

<style lang="scss">
// V-select
.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__selected

/*.style-chooser .vs__dropdown-menu:hover*/
  {
  background: #3e7662;
  border: solid 2px #3e7662;
  color: #fff;
  /*text-transform: lowercase;*/
  /*font-variant: small-caps;*/
}

.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
  fill: #fff;
}
</style>
